export default {
  zh: {
    device_manage: '设备管理',
    title: '当前账号支持 | 台设备同时连接 | 台设备同时连接',
    add_device: '增加设备',
    device: '设备',
    no_data: '没有设备连接记录',
    delete_btn: '断开连接',
    new_tips: '设备连接时可以保护隐私和网络安全，建议保持连接状态',
    manage: '管理：',
    is_loading: '正在加载...'
  },
  en: {
    device_manage: 'Device Management',
    title: 'Current account supports | device to connect simultaneously | devices to connect simultaneously',
    add_device: 'Add Devices',
    device: 'Device',
    no_data: 'No Device Connection Records',
    delete_btn: 'Disconnect',
    new_tips: 'Your privacy and Internet security can be protected when the device is connected. It is recommended to keep the connection status',
    manage: 'Manage: ',
    is_loading: 'Loading...'
  }
}



// WEBPACK FOOTER //
// ./src/components/deviceManagement/lang.js